import gql from 'graphql-tag';

export const FavouriteSpaceQuery = gql`
	query FavouriteSpaceQuery($spaceKey: String!) {
		space(key: $spaceKey) {
			id
			currentUser {
				isFavourited
			}
		}
	}
`;
